// Single source of truth for board views.
//
// Add a view here → it appears in the Navbar toggle (icon + tooltip + order)
// and, for non-kanban views, renders in Board.js. The kanban ('board') view is
// still rendered inline in Board.js because it's tightly coupled to the
// virtualizer; the registry owns its label/icon/order so the toggle stays
// consistent. New views (table, timeline, gantt) only need a registry entry +
// a component — no Board.js/Navbar churn.

import ViewColumn2 from '../icons/ViewColumn2';
import ListAlt from '../icons/ListAlt';
import CalendarMonth from '../icons/CalendarMonth';

export const BOARD_VIEWS = {
    board: { key: 'board', label: 'Board View', icon: ViewColumn2 },
    list: { key: 'list', label: 'List View', icon: ListAlt },
    calendar: { key: 'calendar', label: 'Calendar View', icon: CalendarMonth },
};

// Render/toggle order.
export const VIEW_ORDER = ['board', 'list', 'calendar'];

// Valid view keys (mirrors the backend User.settings.boardViewMode enum).
export const isValidViewMode = (mode) => VIEW_ORDER.includes(mode);
